// extracted by mini-css-extract-plugin
export default {"wrapper":"replyPageContent_wrapper__BD16l","content":"replyPageContent_content__472Zv","blinker":"replyPageContent_blinker__afCeS"};